(function () {
  if (window.__leveretGcrBadge) return;
  window.__leveretGcrBadge = true;

  var current = document.currentScript;
  var merchantId = current && current.getAttribute('data-merchant-id');
  if (!merchantId || !/^\d+$/.test(merchantId)) return;
  merchantId = Number(merchantId);

  var shell = document.getElementById('leveret-gcr-badge');
  if (!shell) {
    shell = document.createElement('div');
    shell.id = 'leveret-gcr-badge';
    shell.setAttribute('aria-hidden', 'true');
    (document.body || document.documentElement).appendChild(shell);
  }

  var started = false;

  function badgeSettled() {
    var badge = document.getElementById('___ratingbadge_0');
    if (!badge || !shell.contains(badge)) return false;
    var rect = badge.getBoundingClientRect();
    return rect.width >= 70 && rect.width <= 110 && rect.height >= 48 && rect.height <= 90;
  }

  function reveal() {
    if (!shell.classList.contains('is-shown')) shell.classList.add('is-shown');
    shell.removeAttribute('aria-hidden');
  }

  function watchBadge() {
    if (badgeSettled()) {
      reveal();
      return;
    }
    var observer = new MutationObserver(function () {
      if (!badgeSettled()) return;
      observer.disconnect();
      reveal();
    });
    observer.observe(shell, { attributes: true, childList: true, subtree: true, attributeFilter: ['style'] });
    window.setTimeout(function () {
      observer.disconnect();
      reveal();
    }, 3000);
  }

  function renderBadge() {
    var existing = document.getElementById('___ratingbadge_0');
    if (existing && !shell.contains(existing)) return;
    if (!window.gapi || !window.gapi.load) return;
    var slot = shell.querySelector('[data-gcr-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.setAttribute('data-gcr-slot', '');
      shell.appendChild(slot);
    }
    window.gapi.load('ratingbadge', function () {
      existing = document.getElementById('___ratingbadge_0');
      if (existing && !shell.contains(existing)) return;
      window.gapi.ratingbadge.render(slot, {
        merchant_id: merchantId,
        position: 'BOTTOM_RIGHT'
      });
      watchBadge();
    });
  }

  function loadBadge() {
    if (started) return;
    started = true;
    var existing = document.getElementById('___ratingbadge_0');
    if (existing && !shell.contains(existing)) return;
    if (window.gapi && window.gapi.load) {
      renderBadge();
      return;
    }
    var platform = document.querySelector('script[src*="apis.google.com/js/platform.js"]');
    if (platform) {
      if (platform.getAttribute('data-leveret-gcr') === '1') return;
      platform.addEventListener('load', renderBadge);
      return;
    }
    window.renderBadge = renderBadge;
    var badge = document.createElement('script');
    badge.src = 'https://apis.google.com/js/platform.js?onload=renderBadge';
    badge.async = true;
    badge.setAttribute('data-leveret-gcr', '1');
    document.head.appendChild(badge);
  }

  var events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  var options = { passive: true, capture: true };
  function start() {
    events.forEach(function (name) {
      window.removeEventListener(name, start, options);
    });
    loadBadge();
  }
  events.forEach(function (name) {
    window.addEventListener(name, start, options);
  });
})();
